/* eslint-disable */

import type { PopFinishesCarouselSlideData } from '../PopFinishes/types';

const finishesCarouselSlides: PopFinishesCarouselSlideData[] = [
  {
    image: {
      alt: '',
      srcSet: [
        {
          media: '(max-width: 767px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-silver.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.48&fp-y=0.53&fp-z=1.5',
        },
        {
          media: '(min-width: 768px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-silver.png?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.51&fp-z=1.15',
        },
      ],
    },
    swatch: {
      label: 'product_catalog_color_silver',
      image: '/blue-sky/pop/gen4/swatch-silver.png',
    },
  },
  {
    image: {
      alt: '',
      srcSet: [
        {
          media: '(max-width: 767px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-black-v2.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.55&fp-z=1.25',
        },
        {
          media: '(min-width: 768px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-black.png?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1',
        },
      ],
    },
    swatch: {
      label: 'product_catalog_color_black',
      image: '/blue-sky/pop/gen4/swatch-black.png',
    },
  },
  {
    image: {
      alt: '',
      srcSet: [
        {
          media: '(max-width: 767px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-brushed-silver.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.51&fp-y=0.53&fp-z=1.15',
        },
        {
          media: '(min-width: 768px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-brushed-silver.png?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1',
        },
      ],
    },
    swatch: {
      label: 'product_catalog_color_brushed_silver',
      image: '/blue-sky/pop/gen4/swatch-brushed-silver.png',
    },
  },
  {
    image: {
      alt: '',
      srcSet: [
        {
          media: '(max-width: 767px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-stealth.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.65&fp-z=1.15',
        },
        {
          media: '(min-width: 768px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-stealth.png?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.54&fp-z=1',
        },
      ],
    },
    swatch: {
      label: 'product_catalog_color_stealth',
      image: '/blue-sky/pop/gen4/swatch-stealth.png',
    },
  },
  {
    image: {
      alt: '',
      srcSet: [
        {
          media: '(max-width: 767px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-gold.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.49&fp-y=0.55&fp-z=1.35',
        },
        {
          media: '(min-width: 768px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-gold.png?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.49&fp-y=0.53&fp-z=1.15',
        },
      ],
    },
    swatch: {
      label: 'product_catalog_color_gold',
      image: '/blue-sky/pop/gen4/swatch-gold.png',
    },
  },
  {
    image: {
      alt: '',
      srcSet: [
        {
          media: '(max-width: 767px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-rose-gold.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.52&fp-y=0.57&fp-z=1.1',
        },
        {
          media: '(min-width: 768px)',
          src: '/blue-sky/pop/gen4/finishes-carousel-slide-rose-gold.png?ar=2:1&fit=crop&crop=focalpoint&fp-x=0.51&fp-y=0.53&fp-z=1.1',
        },
      ],
    },
    swatch: {
      label: 'product_catalog_color_rosegold',
      image: '/blue-sky/pop/gen4/swatch-rose-gold.png',
    },
  },
];

export default finishesCarouselSlides;
